/**
 * Countries offered at registration.
 *
 * Not the full ISO 3166 list. Canary and European goldfinch keeping is concentrated in
 * Europe and around the Mediterranean, and the registration form is the first thing a
 * breeder sees — a 250-entry dropdown to find "Netherlands" is a worse first impression
 * than a short list with an explicit escape hatch. Codes are ISO 3166-1 alpha-2, which is
 * what `Breeder.CountryCode` stores and what federation conventions key on.
 */

export interface Country {
  /** ISO 3166-1 alpha-2. */
  code: string;
  name: string;
}

export const COUNTRIES: readonly Country[] = [
  { code: "NL", name: "Netherlands" },
  { code: "BE", name: "Belgium" },
  { code: "DE", name: "Germany" },
  { code: "FR", name: "France" },
  { code: "IT", name: "Italy" },
  { code: "ES", name: "Spain" },
  { code: "PT", name: "Portugal" },
  { code: "GB", name: "United Kingdom" },
  { code: "IE", name: "Ireland" },
  { code: "AT", name: "Austria" },
  { code: "CH", name: "Switzerland" },
  { code: "PL", name: "Poland" },
  { code: "CZ", name: "Czechia" },
  { code: "SK", name: "Slovakia" },
  { code: "HU", name: "Hungary" },
  { code: "SI", name: "Slovenia" },
  { code: "HR", name: "Croatia" },
  { code: "RS", name: "Serbia" },
  { code: "GR", name: "Greece" },
  { code: "TR", name: "Türkiye" },
  { code: "MT", name: "Malta" },
  { code: "CY", name: "Cyprus" },
  { code: "DK", name: "Denmark" },
  { code: "SE", name: "Sweden" },
  { code: "NO", name: "Norway" },
  { code: "FI", name: "Finland" },
  { code: "MA", name: "Morocco" },
  { code: "DZ", name: "Algeria" },
  { code: "TN", name: "Tunisia" },
  { code: "EG", name: "Egypt" },
  { code: "BR", name: "Brazil" },
  { code: "AR", name: "Argentina" },
  { code: "MX", name: "Mexico" },
  { code: "US", name: "United States" },
  { code: "CA", name: "Canada" },
  { code: "AU", name: "Australia" },
  { code: "ZA", name: "South Africa" },
  { code: "IN", name: "India" },
  { code: "ID", name: "Indonesia" },
  { code: "JP", name: "Japan" },
];

/** The display name for a code, falling back to the code itself for anything unlisted. */
export function countryName(code: string | null | undefined): string {
  if (!code) {
    return "";
  }

  const upper = code.toUpperCase();
  return COUNTRIES.find((country) => country.code === upper)?.name ?? upper;
}

/** True when the value is shaped like an ISO alpha-2 code, whether or not it is listed. */
export function isCountryCode(value: string | null | undefined): boolean {
  return typeof value === "string" && /^[A-Za-z]{2}$/.test(value);
}
